module.exports = __webpack_public_path__ + "img/T1A_xs_3.6255a084.png";